import React, { useCallback } from 'react'
import { FlatList } from 'react-native'
import { BaseIngredient } from '@screens/Ingredients/types'
import { ingredientsAreEqual } from '@screens/Ingredients/utils'
import { CreateNewIngredientButton, IngredientItem } from '@screens/Ingredients'
import { Ingredient } from '@src/types'

const keyExtractor = (item: BaseIngredient) => item.id

export const IngredientsList = React.memo(
  ({
    ingredients,
    isCustomTab,
    addedIngredients,
    onItemSelect,
    onRemovePress,
    contentContainerStyle,
  }: {
    ingredients: BaseIngredient[]
    isCustomTab?: boolean
    addedIngredients: (Ingredient | BaseIngredient)[]
    onItemSelect: (item: BaseIngredient) => void
    onRemovePress: (item: BaseIngredient) => void
    contentContainerStyle: { paddingBottom: number }
  }) => {
    const renderItem = useCallback(
      ({ item }: { item: BaseIngredient }) => {
        const isAddedIngredient = addedIngredients.some((addedIngredient) =>
          ingredientsAreEqual(addedIngredient, item),
        )

        return (
          <IngredientItem
            hasPlusIcon={!isAddedIngredient}
            item={item}
            onItemSelect={onItemSelect}
            onRemovePress={isAddedIngredient ? onRemovePress : undefined}
            showMenu={isCustomTab}
          />
        )
      },
      [addedIngredients, onItemSelect, onRemovePress, isCustomTab],
    )

    return (
      <FlatList
        data={ingredients}
        keyExtractor={keyExtractor}
        renderItem={renderItem}
        ListHeaderComponent={isCustomTab ? <CreateNewIngredientButton /> : null}
        contentContainerStyle={contentContainerStyle}
        keyboardShouldPersistTaps="handled"
      />
    )
  },
)
